import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import CheckBox from '../common/checkbox'
import RadioGroup from '../common/radioGroup'
import RadioButton from '../common/radioButton'

export default class Profile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      input: null,
      data: null,
      submitClick: false,
      isFirstLoad: false,
      didFocus: false,
      verError: false
    }
    
    this.next = this._next.bind(this)
    this.back = this._back.bind(this)
    this.verificationError = this._verificationError.bind(this)
  }

  async componentDidMount() {
    try {
      const { mostRecentPage, pageNumber, history, qnaData } = this.props
      if (mostRecentPage > 6 && pageNumber === 6) {
        history.push('/6' + history.location.search)
      } else if (mostRecentPage < pageNumber) {
        history.push('/' + mostRecentPage + history.location.search)
      }
      this.setState({ isFirstLoad: true, data: qnaData })
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    try {
      if (this.props.pageNumber !== prevProps.pageNumber || !prevState.isFirstLoad) {
        this.props.updateActivePage(this.props.pageNumber)
        let questions = {}
        for (let i = 0; i < this.props.questions.length; i++) {
          let question = this.props.questions[i]
          if (i === 0) this.firstQuestion = question
          if (question.key === 'height-feet') this.savedQuestion = question
          switch(question.type) {
            case 'checkbox':
              let checkBoxGroup = {}
              for (let j = 0; j < question.fields.length; j++) {
                let checkBoxValue = question.fields[j].value
                let checkBoxName = question.fields[j].id
                if (this.state.data && this.state.data[question.key]) {
                  this.state.data[question.key].value.includes(checkBoxName) ? checkBoxGroup[checkBoxValue] = true : checkBoxGroup[checkBoxValue] = false
                } else {
                  checkBoxGroup[checkBoxValue] = false
                }
              }
              questions[question.key] = { value: checkBoxGroup, type: question.type, required: question.options.visible }
            break
            case 'radio':
              if (this.state.data && this.state.data[question.key]) {
                let fieldValue;
                for (let j = 0; j < question.fields.length; j++) {
                  let checkBoxName = question.fields[j].id
                  fieldValue = this.state.data[question.key].value.includes(checkBoxName) ? question.fields[j].value : fieldValue
                }
                questions[question.key] = { value: fieldValue, type: question.type, required: true }
              } else {
                questions[question.key] = { value: '', type: question.type, required: question.options.visible }
              }
            break
            default:
              if (this.state.data && this.state.data[question.key]) {
                questions[question.key] = { value: this.state.data[question.key].value, type: question.type, required: true }
              } else {
                questions[question.key] = { value: '', type: question.type, required: question.options.visible }
              }
            break
          }
        }
    
        this.branches = {}
        for (let property in this.props.questions) {
          if (this.props.questions[property].branching) {
            this.branches[this.props.questions[property].key] = this.props.questions[property].branching
          }
        }
        this.focusElements = {}
        for (let name in this.state.input) {
          this.focusElements[name] = React.createRef()
        }
        let newInputState = this.updateFromHistory(this.props.history.location.state, questions)
        this.setState({
          input: {
            ...questions,
            ...newInputState
          },
          submitClick: false,
          didFocus: false
        })
      }
      if (this.firstQuestion && !this.state.didFocus && this.props.pageNumber === prevProps.pageNumber && this.focusElements[this.firstQuestion.key]) {
        this.setState({ didFocus: true })
        var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
        focusable && focusable[0] && focusable[0].focus() 
        window.scrollTo(0, 0)
      }
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }
 
  updateFromHistory(historyState, questions) {
    try {
      if (historyState) {
        let newInputState = {}
        for (let property in questions) {
          if (questions[property] !== undefined && historyState[property]) {
            newInputState[property] = historyState[property]
          }
        }
        return newInputState
      }
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  closeBranches(name, currentBranch, newInput) {
    try {
      if (!currentBranch) {
        return newInput
      }
      switch(this.state.input[name].type) {
        case 'checkbox':
          for (let property in newInput[currentBranch.branch].value) {
            if(newInput[currentBranch.branch].type === "text")
              newInput[currentBranch.branch].value = ''
            else
              newInput[currentBranch.branch].value[property] = false
          }
          break
        default: 
          newInput[currentBranch.branch].value = ''
        break
      }
      newInput[currentBranch.branch].required = false
      return this.closeBranches(currentBranch.branch, this.branches[currentBranch.branch] ? this.branches[currentBranch.branch][0] : null, newInput)
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  changeState(name, valueOrEvent, isRequired, currentBranch) {
    try {
      let newInput = this.state.input
      let newState = this.state
      switch(this.state.input[name].type) {
        case 'radio': 
          if (!isRequired) {
            newInput = this.closeBranches(name, currentBranch, newInput)
          } else {
            newInput[currentBranch.branch].required = isRequired
          }
          newInput[name].value = valueOrEvent
          newState.input = newInput
        break
        case 'text':
          newState.input = { ...this.state.input,
            [name]: {...this.state.input[name], 
              value: valueOrEvent
            }
          }
        break
        case 'checkbox':
          let checkboxGroupValue = this.state.input[name].value
          checkboxGroupValue[valueOrEvent] = !checkboxGroupValue[valueOrEvent]
          if (!isRequired) {
            newInput = this.closeBranches(name, currentBranch, newInput)
          } else {
            newInput[currentBranch.branch].required = isRequired
          }
          if (checkboxGroupValue['none'] || checkboxGroupValue['other']) {
            if (valueOrEvent !== 'none' && valueOrEvent !== 'other') {
              if (checkboxGroupValue['none']) checkboxGroupValue['none'] = false
              if (checkboxGroupValue['other']) checkboxGroupValue['other'] = false
            } else {
              for (let allergies in checkboxGroupValue) {
                if (allergies !== valueOrEvent) {
                  checkboxGroupValue[allergies] = false
                }
              }
            }
          }
          newInput[name].value = checkboxGroupValue
          newState.input = newInput    
        break
        default: break
      }
      this.setState(newState, () => {this.props.updateHistory(this.state, this.props.history)})
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  handleChange(name, valueOrEvent) {
    try {
      let isRequired = false
      switch(this.state.input[name].type) {
        case 'radio':
          if (this.branches[name]) {
            for (let i in this.branches[name]) {
              let isRequired = false
              if (this.branches[name][i] && this.branches[name][i].value === valueOrEvent) {
                isRequired = true
              }
              this.changeState(name, valueOrEvent, isRequired, this.branches[name][i])
            }
          } else {
            this.changeState(name, valueOrEvent, isRequired)
          }
        break
        case 'text':
          const curEvent = valueOrEvent.target.value
          let regex = new RegExp(this.getRegex(name))
          if (regex.test(curEvent)) {
            this.changeState(name, curEvent)
          }
        break
        case 'checkbox':
          if (this.branches[name] && this.branches[name][0].value === valueOrEvent && !this.state.input[name].value[valueOrEvent]) {
            isRequired = true
          }
          this.changeState(name, valueOrEvent, isRequired, this.branches[name] ? this.branches[name][0] : null)
        break
        default: break
      }
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  makeRef(name, ref) {
    try {
      this.focusElements[name] = ref
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  _back() {
    try {
      return this.props.back(this.props.match.path, this.state.input, this.props.pageNumber)
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  _next(e) {
    try {
      this.setState({ submitClick: true })
      for (let property in this.state.input) {
        if (!this.isValid(property)) {
          this.focusElements[property].focus()
          e.preventDefault()
          return
        }
      }
      return this.props.next(this.props.match.path, this.state.input, this.props.pageNumber)
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  isEmpty(name) {
    try {
      if (this.state.input[name].value === '') return true
      return false
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  checkTextValue(name) {
    try {
      let question = null
      for (let index in this.props.questions) {
        if (this.props.questions[index].key === name) {
          question = this.props.questions[index]
        }
      }
      if (question.validation.min && question.validation.max && (this.state.input[name].value < parseInt(question.validation.min) || this.state.input[name].value > parseInt(question.validation.max))) {
        return false
      }
      return true
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  getRegex(name) {
    try {
      let result
      this.props.questions.map(question => {
        if (question.key === name) {
          result = question.validation.regex
        }
        return null
      })
      return result
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  isValid(name) {
    try {
      if (!this.state.input[name].required) {
        return true
      }
      switch (this.state.input[name].type) {
        case 'radio':
          return !this.isEmpty(name)
        case 'checkbox':
          let valid = false
          for (let check in this.state.input[name].value) {
            if (this.state.input[name].value[check] === true) {
              valid = true
            }
          }
          return valid
        case 'text':
          if (this.isEmpty(name)) return false
          let regex = new RegExp(this.getRegex(name))
          if (regex.test(this.state.input[name].value) && this.checkTextValue(name)) {
            return true
          }
          return false
        default: return false
      }
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  displayError(name, validationMessage) {
    try {
      if (this.state.submitClick) {
        if (!this.isValid(name)) {
          switch (this.state.input[name].type) {
            case 'radio':
              return (
                <div id={`profile_${name}_error`} className="error">{validationMessage.rqerror}</div>
              )
            case 'checkbox':
              return (
                <div id={`profile_${name}_error`} className="error">{validationMessage.rqerror}</div>
              )
            case 'text':
              if (this.isEmpty(name)) {
                return (
                  <div id={`profile_${name}_error`} className="error">{validationMessage.rqerror}</div>
                )
              } else if (!this.checkTextValue(name)) {
                return (
                  <div id={`profile_${name}_error`} className="error">{validationMessage.mmerror}</div>
                )
              }
              return (
                <div id={`profile_${name}_error`} className="error">{validationMessage.rgxerror}</div>
              )
            default:
          }
        }
      }
      return (
        <div id={`profile_${name}_error`} className="error"></div>
      )
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  initialRadioGroupValue(question) {
    try {
      if (this.props.history.location.state && this.props.history.location.state[question.key]) {
        return this.props.history.location.state[question.key].value
      }
      return this.state.input[question.key].value
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  _verificationError() {
    try {
      let errorText = ""
      if (this.props.verError) {
        errorText = "Something went wrong. Please try again or call Client Care at 1-888-639-8181."
      }
      return (
        <div aria-live="polite" className="error">{errorText}</div>
      )
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  generateRadioGroup(question) {
    try {
      if (question.key === 'energy' || question.key === 'stress-level' || question.key === 'sleep-quality') {
        return (
          <RadioGroup
            className="radio-button-wrap"
            name={question.key}
            initial={this.initialRadioGroupValue(question)}
            radioRef={this.makeRef.bind(this, question.key)}
            onChange={this.handleChange.bind(this, question.key)}
            ariaLabelledby={`profile_${question.key}_text`}
            ariaDescribedby={`profile_${question.key}_error`}
          >
            {question.fields.map(field => 
              <RadioButton key={field.text} value={field.value} label={field.text} />
            )}
          </RadioGroup>
        )
      }
      return (
        <RadioGroup
          name={question.key}
          initial={this.initialRadioGroupValue(question)}
          radioRef={this.makeRef.bind(this, question.key)}
          onChange={this.handleChange.bind(this, question.key)}
          ariaLabelledby={`profile_${question.key}_text`}
          ariaDescribedby={`profile_${question.key}_error`}
        >
          {question.fields.map(field => 
            <RadioButton key={field.text} value={field.value} label={field.text} />
          )}
        </RadioGroup>
      )
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  generateComponent(question) {
    try {
      if (!this.state.input || !this.state.input[question.key] || !this.state.input[question.key].required) {
        return
      }
      switch(question.type) {
        case 'radio':
          return (
            <div className="form-input">
              <div id={`profile_${question.key}_text`}>
              <h3>{question.text}</h3>
                <p>{question.microcopy}</p>
              </div>
              {this.generateRadioGroup(question)}
              {this.displayError(question.key, question.validation)}           
            </div>
          )
        case 'text':
          if (question.key === 'height-feet') {
            return
          } else if (question.key === 'height-inches') {
            return (
              <div className="form-input">
                <label for="height" id={`profile_${question.key}_text`}>
                  <div className="form-heading">
                    {this.savedQuestion.text}
                  </div>
                  <p>{this.savedQuestion.microcopy}</p>
                </label>
                <div role="group" className="form-row" aria-labelledby={`profile_${question.key}_text`}>
                  <div>
                    <input
                      id="height"
                      ref={this.makeRef.bind(this, this.savedQuestion.key)}
                      value={this.state.input[this.savedQuestion.key].value}
                      type={this.savedQuestion.type}
                      aria-label="Feet"
                      aria-describedby={`profile_${this.savedQuestion.key}_error`} 
                      placeholder={question.placeholder || "Enter description here"}
                      onChange={this.handleChange.bind(this, this.savedQuestion.key)}
                    />
                    {this.displayError(this.savedQuestion.key, this.savedQuestion.validation)}
                  </div>
                  <div>
                    <input
                      ref={this.makeRef.bind(this, question.key)}
                      value={this.state.input[question.key].value}
                      type={question.type}
                      aria-label="Inches"
                      aria-describedby={`profile_${question.key}_error`}
                      placeholder={question.placeholder || "Enter description here"}
                      onChange={this.handleChange.bind(this, question.key)}
                    />
                    {this.displayError(question.key, question.validation)} 
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div className="form-input">
                <div id={`profile_${question.key}_text`}>
                  <label for={question.key}>
                    <div className="form-heading">
                      {question.text}
                    </div>
                    <p>{question.microcopy}</p>
                  </label>
                </div>
                <input
                  id ={question.key}
                  ref={this.makeRef.bind(this, question.key)}
                  value={this.state.input[question.key].value}
                  type={question.type}
                  aria-labelledby={`profile_${question.key}_text`}
                  aria-describedby={`profile_${question.key}_error`}
                  placeholder={question.placeholder || "Enter description here"}
                  onChange={this.handleChange.bind(this, question.key)}
                />
                {this.displayError(question.key, question.validation)} 
              </div>
            )
          }
        case 'checkbox':
          return (
              <div className="form-input">
                <div role="group" aria-labelledby={`profile_${question.key}_text`}>
                  <div id={`profile_${question.key}_text`}>
                    <h3>{question.text}</h3>
                    <p>{question.microcopy}</p>
                  </div>
                  {Object.keys(this.state.input[question.key].value).map((checkboxName, index) => {
                    return (
                      <CheckBox
                        key={checkboxName}
                        value={`${checkboxName}_${question.key}`}
                        checkboxRef={index ? null : this.makeRef.bind(this, question.key)}
                        checked={this.state.input[question.key].value[checkboxName]}
                        ariaDescribedby={`profile_${question.key}_error`}
                        info={question.fields[index].text}
                        onChange={this.handleChange.bind(this, question.key, checkboxName)}
                      />
                    )
                  })}
                </div>
                {this.displayError(question.key, question.validation)} 
            </div>
          )
        default: break
      }
      return
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }

  render() {
    try {
      const fields = this.props.questions.map(question => {
        return (
          <div key={question.key}>
            {this.generateComponent(question)}
          </div>
        )
      })
      return (
        <div>
          <AriaMessage message="Navigated to personal profile page" />
          <Title>{this.props.title}</Title>
          <div className="container">
            <h2>{this.props.header}</h2>
            {fields}
            <Privacy />
            {this.verificationError()}
            <Controls back={this.props.pageNumber === 1 ? null : this.back} next={this.next} />
          </div>
        </div>
      )
    } catch(error) {
      this.props.addErrorLog(error)
    }
  }
}